export const messagesSearch = (array, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return array.filter((value) => {
    return (
      value.subject &&
      value.subject.toLowerCase().match(new RegExp(searchTerm, "g"))
    );
  });
};
